// removed by extract-text-webpack-plugin
module.exports = {"gw_offering_summary":"MobileCoverageSummary-hashed__gw_offering_summary__3sny8","gw_summarized_coverage":"MobileCoverageSummary-hashed__gw_summarized_coverage__3G5rB","gw_offering_header_accordion_label":"MobileCoverageSummary-hashed__gw_offering_header_accordion_label__3ZOxF"};


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/quoteandbind/common/directives/CommonOfferingSelection/mobileQuoteView/mobile-coverage-summary/MobileCoverageSummary-hashed.scss
// module id = 677
// module chunks = 0